export var CustomMessages;
(function (CustomMessages) {
    CustomMessages["CLICK_CAST"] = "castButtonClick";
    CustomMessages["CLICK_GO_BACK_TO_LIVE"] = "clickGoBackToLive";
    CustomMessages["CLICK_WATCH_FROM_START"] = "clickWatchFromStart";
    CustomMessages["DO_ERROR"] = "doError";
    CustomMessages["ERROR_TRIGGERED"] = "errorTriggerd";
    CustomMessages["JAVASCRIPT_READY"] = "javascriptReady";
    CustomMessages["PLAY_NEXT_CANCEL_CLICK"] = "playNextCancelClick";
    CustomMessages["PLAY_NEXT_COUNTDOWN_CANCELED"] = "playNextCountdownCanceled";
    CustomMessages["PLAY_NEXT_COUNTDOWN_FINISHED"] = "playNextCountdownFinished";
    CustomMessages["PLAY_NEXT_COUNTDOWN_PROGRESS"] = "playNextCountdownProgress";
    CustomMessages["PLAY_NEXT_OVERLAY_HIDDEN"] = "playNextOverlayHidden";
    CustomMessages["PLAY_NEXT_OVERLAY_HIDE"] = "playNextOverlayHide";
    CustomMessages["PLAY_NEXT_OVERLAY_SHOW"] = "playNextOverlayShow";
    CustomMessages["PLAY_NEXT_OVERLAY_SHOWN"] = "playNextOverlayShown";
    CustomMessages["PLAY_NEXT_PROCEED_CLICK"] = "playNextProceedClick";
    CustomMessages["SET_STREAM_LINK"] = "setStreamLink";
    CustomMessages["SET_WEB_DATA"] = "setWebData";
    CustomMessages["TOGGLE_AIRPLAY"] = "toggleAirplay";
    CustomMessages["TOGGLE_FULLSCREEN"] = "toggleFullScreen";
    CustomMessages["TOGGLE_FULLSCREEN_UI"] = "toggleFullscreenUI";
    CustomMessages["TOGGLE_MUTE"] = "toggleMute";
    CustomMessages["TOGGLE_PIP"] = "togglePiP";
    CustomMessages["TOGGLE_PLAY_PAUSE"] = "togglePlayPause";
    CustomMessages["TOGGLE_SETTINGS_PANEL"] = "toggleSettingsPanel";
})(CustomMessages || (CustomMessages = {}));
export var NpoPlayerUIVariants;
(function (NpoPlayerUIVariants) {
    NpoPlayerUIVariants["DEFAULT"] = "default";
    NpoPlayerUIVariants["AUDIO"] = "audio";
    NpoPlayerUIVariants["VERTICAL"] = "vertical";
    NpoPlayerUIVariants["AD"] = "ad";
})(NpoPlayerUIVariants || (NpoPlayerUIVariants = {}));
export var ViewMode;
(function (ViewMode) {
    ViewMode["Inline"] = "inline";
    ViewMode["Fullscreen"] = "fullscreen";
    ViewMode["PictureInPicture"] = "pictureinpicture";
})(ViewMode || (ViewMode = {}));
export var LocalStorageValues;
(function (LocalStorageValues) {
    LocalStorageValues["IS_MUTED"] = "ismuted";
    LocalStorageValues["VOLUME"] = "volume";
    LocalStorageValues["SUBTITLES_ENABLED"] = "subtitles_enabled";
})(LocalStorageValues || (LocalStorageValues = {}));
